import { Event } from "@app/core/tracking/domain/event";

/**
 * Service responsible for managing and notifying events within the application.
 */
export abstract class EventService {
    abstract notify(event: Event): void;
}